import React from 'react';
import { deleteRecipe } from '../api';
import { useParams, useNavigate } from 'react-router-dom';

const DeleteRecipePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await deleteRecipe(id);
      alert('Recette supprimée avec succès !');
      navigate('/'); // Redirige vers la page d'accueil
    } catch (err) {
      alert(`Erreur : ${err.message}`);
    }
  };

  return (
    <div className="form-container">
      <h2>Supprimer une Recette</h2>
      <p>Êtes-vous sûr de vouloir supprimer cette recette ?</p>
      <button onClick={handleDelete}>Supprimer</button>
      <button onClick={() => navigate('/')}>Annuler</button>
    </div>
  );
};

export default DeleteRecipePage;